import { CancelRounded } from '@mui/icons-material';
import { Box, Card, IconButton, Paper, Slide, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SchoolIcon } from '../../../svg';
import { ClientModel } from '../types.ts';

interface Props {
  open: boolean;
  onClose: (value: boolean) => void;
  data?: ClientModel;
}
const SchoolInfoBox = (props: Props) => {
  const { data, open, onClose } = props;

  const customerType = () => {
    if (!data) return '';
    if (data.type === 'MN') return 'Mầm non';
    if (data.type === 'TH') return 'Tiểu học';
    if (data.type === 'THCS') return 'Trung học cơ sở';
    if (data.type === 'CCNN') return 'Cơ quan nhà nước';
  };

  return (
    <>
      <Slide direction="right" in={open} unmountOnExit>
        <Paper
          sx={(theme) => ({
            width: 320,
            [theme.breakpoints.up('laptop')]: {
              width: 360,
            },
            [theme.breakpoints.up('desktop')]: {
              width: 420,
            },
          })}
          className="flex flex-col h-full overflow-hidden absolute z-20 p-4 py-6"
        >
          <Tooltip title={<FormattedMessage id="close" />}>
            <IconButton
              onClick={() => onClose(false)}
              size="small"
              color="primary"
              sx={{ position: 'absolute', top: 1, right: 1 }}
            >
              <CancelRounded fontSize="small" />
            </IconButton>
          </Tooltip>
          <Card
            sx={{
              display: 'flex',
              p: 1,
              gap: 2,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'primary.main',
              width: '100%',
            }}
          >
            <SchoolIcon style={{ height: 48, width: 48 }} />
            <Box>
              <Typography>{data?.name}</Typography>
              <Typography variant="caption">
                {[data?.addressDetail, data?.wardName, data?.cityName].join(', ')}
              </Typography>
            </Box>
          </Card>
          <Box className="flex flex-col gap-2 mt-4">
            {[
              {
                title: <FormattedMessage id="map.operationCode" />,
                value: data?.operationCode,
              },
              {
                title: <FormattedMessage id="map.customer" />,
                // value: data?.name,
                //
                value: customerType(),
              },
              {
                title: <FormattedMessage id="website" />,
                value: data?.website,
              },
              {
                title: <FormattedMessage id="map.address" />,
                value: data?.addressDetail,
              },
              {
                title: <FormattedMessage id="map.ward" />,
                value: data?.wardName,
              },
              {
                title: <FormattedMessage id="map.city" />,
                value: data?.cityName,
              },
            ].map((item: any, index) => {
              return (
                <Typography key={index}>
                  {item.title}
                  :&nbsp;{item.value}
                </Typography>
              );
            })}
          </Box>
        </Paper>
      </Slide>
    </>
  );
};
export default SchoolInfoBox;
